import React from "react";
import { Routes, Route } from "react-router-dom";

import WebNavBar from "../../../Container/Website/NavBar/WebNavBar";
import HomePage from "../../../Container/Website/HomePage/HomePage";
import ScrollToTop from "../ScrollToTop";
import LoginPage from "../../../Container/Website/LoginPage/LoginPage";
import ClientLogin from "../../../Container/Website/LoginPage/ClientLogin";
import ClientSignUp from "../../../Container/Website/LoginPage/ClientSignUp";
import Testpage from "../../../Components/Testpage";
import AboutPage from "../../../Container/Website/AboutPage/AboutPage";
import ServicesPage from "../../../Container/Website/ServicesPage/ServicesPage";
import ContactPage from "../../../Container/Website/ContactPage/ContactPage";
import Footer from "../../../Container/Website/Footer/Footer";



const WebsiteRoutes = () => {
  return (
    <>
      <ScrollToTop />

      {/* Navbar */}
      <WebNavBar />

      {/* Page Routes */}
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage/>} />
        <Route path="/services" element={<ServicesPage/>} />
        <Route path="/contact" element={<ContactPage/>} />
        <Route path="/login" element={<LoginPage />} /> 
        <Route path="/client-login" element={<ClientLogin/>} /> 
        <Route path="/client-signup" element={<ClientSignUp/>} /> 
        <Route path="/testpage" element={<Testpage/>} /> 
        
        {/* <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/contact" element={<Contact />} />
        */}
      </Routes>
      <Footer/>
    </>
  );
};

export default WebsiteRoutes;